'use strict';
import '../css/style.scss';
// import '../css/app.scss';


import "./pjax";
// import "./glab";


(function (window, document, $) {
	// sticky化 #vantan-headerが画面外ならsticky
	const vantanHeader = document.querySelectorAll('#vantan-header');
	const vantanHeaderOptions = {
		root: null,
		rootMargin: '0px 0px 0px 0px',
		threshold: 0,
	};
	const vantanHeaderObserver = new IntersectionObserver(
		vantanHeaderIntersectFunction,
		vantanHeaderOptions
	);
	vantanHeader.forEach((item) => {
		vantanHeaderObserver.observe(item);
	});
	function vantanHeaderIntersectFunction(elements) {
		elements.forEach((element) => {
			if (element.isIntersecting) {
				$('body').removeClass('js-vantanHeader-hide');
			} else {
				$('body').addClass('js-vantanHeader-hide');
			}
		});
	}
	//  #vantan-footerが表示されたら固定非表示
	const vantanFooter = document.querySelectorAll('#vantan-footer');
	const vantanFooterOptions = {
		root: null,
		rootMargin: '10px 0px 0px 0px',
		threshold: 0.5,//0だと最初からきえてたので閾値を下げる
	};
	const vantanFooterObserver = new IntersectionObserver(
		vantanFooterIntersectFunction,
		vantanFooterOptions
	);
	vantanFooter.forEach((item) => {
		vantanFooterObserver.observe(item);
	});
	function vantanFooterIntersectFunction(elements) {
		elements.forEach((element) => {
			if (element.isIntersecting) {
				$('body').addClass('js-fixed_floating-hide');
			} else {
				$('body').removeClass('js-fixed_floating-hide');
			}
		});
	}

	//画面固定のcvボタンの表示非表示切り替え (交差API
	// .sct-main内のcv_btnが表示されているときと.sct-documentが表示されているときは固定cvボタンを非表示
	const sectionDocument = document.querySelectorAll('.sct-document');
	const sectionMainBtn = document.querySelectorAll('.sct-main .a-cv_btn_wrap');
	//.sct-documentが1px、ビューポートの中にはいったら発火
	const sectionDocumentOptions = {
		root: null, // ビューポートはウィンドウ全体
		rootMargin: '0px 0px 0px 0px',
		threshold: 0, // 1ピクセルでも表示されるとコールバックが実行
	};
	const sectionMainBtnOptions = {
		root: null,
		rootMargin: '0px 0px 500px 0px', //FV内にcvbtnが出ていない実機を考慮し下方向の監視範囲を広げる
		threshold: 0,
	};

	function IntersectFunction2(elements) {
		// 交差監視をしたもののなかで、isIntersectingがtrueになったとき
		elements.forEach((element) => {
			if (element.isIntersecting) {
				$('body').removeClass('js-elementShow');
			} else {
				$('body').addClass('js-addAnim');
				$('body').addClass('js-elementShow');
			}
		});
	}
	const observer = new IntersectionObserver(
		IntersectFunction,
		sectionDocumentOptions
	);
	sectionDocument.forEach((item) => {
		observer.observe(item);
	});
	function IntersectFunction(elements) {
		// 交差監視をしたもののなかで、isIntersectingがtrueになったとき
		elements.forEach((element) => {
			if (element.isIntersecting) {
				$('body').removeClass('js-elementShow');
			} else {
				const observer2 = new IntersectionObserver(
					IntersectFunction2,
					sectionMainBtnOptions
				);
				sectionMainBtn.forEach((item) => {
					observer2.observe(item);
				});
			}
		});
	}
})(window, document, jQuery);
